<template>
  <div class="questions-answer__box">
    <container>
      <Questions :ques="questions"/>
    </container>
  </div>
</template>

<script>
import Questions from '@/components/Questions'
export default {
  name: 'UniQuestionsAnswer',
  components: {
    Questions
  },
  data () {
    return {
      questions: [
        {
          id: 0,
          date: '18 Mart 2018',
          logo: require('@/assets/img/comment-photo.png'),
          name: 'Şahin Zaybak',
          location: '18 Mart 2018',
          text: 'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.',
          answers: [
            {
              id: 0,
              date: '18 Mart 2018',
              logo: require('@/assets/img/comment-photo.png'),
              name: 'Şahin Zaybak',
              location: '18 Mart 2018',
              text: 'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.'
            },
            {
              id: 1,
              date: '18 Mart 2018',
              logo: require('@/assets/img/comment-photo.png'),
              name: 'Şahin Zaybak',
              location: '18 Mart 2018',
              text: 'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.'
            }
          ]
        },
        {
          id: 1,
          date: '18 Mart 2018',
          logo: require('@/assets/img/comment-photo.png'),
          name: 'Şahin Zaybak',
          location: '18 Mart 2018',
          text: 'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.'

        },
        {
          id: 2,
          date: '18 Mart 2018',
          logo: require('@/assets/img/comment-photo.png'),
          name: 'Şahin Zaybak',
          location: '18 Mart 2018',
          text: 'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.'

        },
        {
          id: 3,
          date: '18 Mart 2018',
          logo: require('@/assets/img/comment-photo.png'),
          name: 'Şahin Zaybak',
          location: '18 Mart 2018',
          text: 'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.'

        },
        {
          id: 4,
          date: '18 Mart 2018',
          logo: require('@/assets/img/comment-photo.png'),
          name: 'Şahin Zaybak',
          location: '18 Mart 2018',
          text: 'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.' +
          ''
        }
      ]
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/questions-answer";
</style>
